import { PropsWithChildren, createContext, useState } from "react";

import { ModalState } from "./types";
import { Backdrop, Modal } from "./styles";

export const ModalContext = createContext<ModalState>({
  Component: null,
  show: () => {
    throw new Error("No ModalContext Provider was detected");
  },
  dismiss: () => {
    throw new Error("No ModalContext Provider was detected");
  },
});

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const [Component, setComponent] = useState<JSX.Element | null>(null);

  const show = (NewComponent: JSX.Element) => {
    setComponent(NewComponent);
  };

  const dismiss = () => {
    setComponent(null);
  };

  const renderBackdrop = (props: any) => (
    <Backdrop {...props} onClick={dismiss} />
  );

  return (
    <ModalContext.Provider value={{ Component, show, dismiss }}>
      {children}
      <Modal show={Component != null} renderBackdrop={renderBackdrop}>
        {Component}
      </Modal>
    </ModalContext.Provider>
  );
};
